import axios from 'axios';
import { mutate } from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { LoanRestriction } from './interfaces';

const BASE_URL = `/${SERVICES.LENDER}/loanrestriction`;

export const requestCreateRestriction = (data: LoanRestriction) => {
  return mutate(BASE_URL, async() => {
    try {
      await axios.post(BASE_URL, data);

      Notistack.successMessage('Loan Restriction - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateRestriction = (data: LoanRestriction) => {
  const { id, ...payload } = data;

  return mutate(BASE_URL, async() => {
    try {
      await axios.put(`${BASE_URL}/${id}`, payload);

      Notistack.successMessage('Loan Restriction - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteRestriction = (id: string) => {
  return mutate(BASE_URL, async() => {
    try {
      await axios.delete(`${BASE_URL}/${id}`);

      Notistack.successMessage('Loan Restriction - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
